import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import ErrorPage from "../../utils/Error";

export const Authenticated = (props) => {
  const { children } = props;
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    if (!auth.isAuthenticated) {
      navigate("/login", { replace: true, state: { from: location } });
      return;
    }

    // Check if user is an artist or merchant with incomplete profile
    if (auth.user) {
      const isArtist = auth.user.account_type === "artist";
      const isMerchant = auth.user.account_type === "merchant";
      const isArtistProfileIncomplete = auth.user.profile_completion_status === "incomplete";

      // Don't redirect to company info if user is in switched context (merchant acting as artist)
      if (auth.isSwitchedContext && isMerchant) {
        setIsVerified(true);
        return;
      }

      // Check for profile completion using reliable backend status
      const isMerchantProfileIncomplete = isMerchant && auth.user.profile_completion_status !== "complete";

      const isOnArtistDetailsPage = location.pathname === "/artist-details";
      const isOnMerchantCompanyInfoPage = location.pathname === "/merchant/company-info";

      if (isArtist && isArtistProfileIncomplete && !isOnArtistDetailsPage) {
        // Redirect incomplete artists to artist details page
        navigate("/artist-details", { replace: true });
        return;
      }

      if (isMerchant && isMerchantProfileIncomplete && !isOnMerchantCompanyInfoPage) {
        // Redirect incomplete merchants to company info page
        navigate("/merchant/company-info", { replace: true });
        return;
      }

      if (isMerchant && !isMerchantProfileIncomplete && isOnMerchantCompanyInfoPage) {
        // Redirect completed merchants away from company info page
        navigate("/merchant/dashboard", { replace: true });
        return;
      }
    }

    setIsVerified(true);
  }, [auth.isAuthenticated, auth.user, auth.isSwitchedContext, location, navigate]);

  if (!isVerified) {
    return <ErrorPage statusCode={401} />;
  }
  return <>{children}</>;
};

